// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text[data-v-5df00764] {\n  margin-left: 60px;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  font-size: 16px;\n}\n", ""]);
// Exports
module.exports = exports;
